module.exports = __webpack_public_path__ + "media/images/tag-f7ec3d963b86adaa7be0fbb590d215d5.svg";